import React from 'react'
import { Col, Row } from 'reactstrap'
import { FaBookOpen, FaClock, FaEye, FaUsers } from 'react-icons/fa'
import { MdOutlineAirplay, MdTimer } from 'react-icons/md'
import { LogAcessoGetTempoMedioTotalGeral, LogAcessoGetTotaisPosts } from '../../../../Service/ApiService'
import { CORES, formatarMinutos, formatarNumero, useIndicador } from '../helpers'
import { Kpi, KpiIcone, KpiTexto } from '../styles'

function Item({ titulo, valor, detalhe, icone, cor, carregando }) {
  return (
    <Col xl={2} md={4} xs={6}>
      <Kpi cor={cor}>
        <KpiIcone cor={cor}>{icone}</KpiIcone>
        <KpiTexto>
          <span>{titulo}</span>
          <strong>{carregando ? '—' : valor}</strong>
          {detalhe && !carregando && <small>{detalhe}</small>}
        </KpiTexto>
      </Kpi>
    </Col>
  )
}

export default function Indicadores({ filters }) {
  const tempo = useIndicador(LogAcessoGetTempoMedioTotalGeral, filters, () => false)
  const posts = useIndicador(LogAcessoGetTotaisPosts, filters, () => false)
  const t = tempo.data || {}
  const p = posts.data || {}

  return (
    <Row>
      <Item titulo="Acessos" valor={formatarNumero(t.acessos)} icone={<MdOutlineAirplay size={22} />} cor={CORES.primaria} carregando={tempo.status === 'loading'} />
      <Item titulo="Usuários únicos" valor={formatarNumero(t.usuarios)} icone={<FaUsers size={20} />} cor={CORES.azul} carregando={tempo.status === 'loading'} />
      <Item titulo="Tempo assistido" valor={formatarMinutos(t.total)} icone={<FaClock size={20} />} cor={CORES.laranja} carregando={tempo.status === 'loading'} />
      <Item titulo="Tempo médio por usuário" valor={formatarMinutos(t.media)} icone={<MdTimer size={22} />} cor={CORES.amarelo} carregando={tempo.status === 'loading'} />
      <Item titulo="Posts publicados" valor={formatarNumero(p.posts)} icone={<FaBookOpen size={20} />} cor={CORES.verde} carregando={posts.status === 'loading'} />
      <Item titulo="Views" valor={formatarNumero(p.views)} detalhe={`${formatarNumero(p.likes)} likes`} icone={<FaEye size={20} />} cor={CORES.rosa} carregando={posts.status === 'loading'} />
    </Row>
  )
}
